<script>
import AssetableDatatable from '@wielink-application/asset/vue/assets/AssetableDatatable.vue'
export default AssetableDatatable;
</script>
